(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icon-tabs-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initIconTabs(section) {
    const tabs = section.querySelectorAll('.icon-tab');
    const panels = section.querySelectorAll('.icon-tabs-panel');

    if (!tabs.length || !panels.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const panelId = tab.dataset.tab;
        if (!panelId) return;

        tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
        panels.forEach(p => p.setAttribute('aria-hidden', 'true'));

        tab.setAttribute('aria-selected', 'true');
        section.querySelector('#' + panelId)?.setAttribute('aria-hidden', 'false');
      });
    });
  }

  // Init on page load
  document.querySelectorAll('[data-icon-tabs]').forEach(initIconTabs);

  // Init again when Shopify editor reloads sections
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-icon-tabs]');
    if (section) initIconTabs(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
